


import {ethers} from 'ethers'


//import detectEthereumProvider from '@metamask/detect-provider';


const Web3 = {

  async getGetPrice(chain){

    const gas = await this.getGasEstimate(chain)
    const gasPrice =   ethers.BigNumber.from(""+gas.gwei)// ethers.utils.formatUnits(""+gas.gwei, "gwei"); 

    return gasPrice
  },
  async connectWeb3(){
  //  const provider = await detectEthereumProvider();

    let accounts = []
    try {
      accounts  = await window.ethereum.request({ method: 'eth_requestAccounts' });
    } catch (err) {
      console.error(err)
    }
    return accounts[0]
  },

  
  async login(params){

    //const web3 = new Web3(window.ethereum);

    let account = await this.connectWeb3()


    if (account){
      try {
        const nonce = Math.floor(Math.random()*1000000)
        const message = `${params.welcomeMessage}
Connected Wallet address: ${account}
Nonce: ${nonce}`

        const provider = new ethers.providers.Web3Provider(window.ethereum)
        const signer = provider.getSigner()

        const ethAddress = await signer.getAddress()

        const hexMessage = ethers.utils.hexlify(ethers.utils.toUtf8Bytes(message))

        const sign = await signer.signMessage(message)

    //    const sign = await window.ethereum.request({ method: 'personal_sign', params: [hexMessage, account]});

        if (window.ProveAnything.Auth){
          const result = await window.ProveAnything.Auth.Login.connectWallet({
            chain: "ethereum-mainnet",
            message: hexMessage,
            signature: sign,
            address: ethAddress,
          })
          console.log(result)

          if (result.success && params.onSuccess){
            // success
            params.onSuccess()
          }
        } else {
          if (params.onSuccess){
            // successfully signed a message - but didn't auth a login
            params.onSuccess()
          }
        }
      } catch(err) {
        if ( params.onError)
          params.onError(err)
        else        
          console.error(err)
      }

    }


    //console.log(web3.eth.getBlockNumber())
   // console.log(web3.eth.coinbase())
    
  }
}

export default Web3;
